module.exports = __webpack_public_path__ + "static/media/logo.9075681c.jpg";